import actionsStore from "./actions";
import mutationsStore from "./mutations";
import gettersStore from "./getters";
import stateStore from "./state";

export const actions = actionsStore;

export const mutations = mutationsStore;

export const getters = gettersStore;

export const state = stateStore;
